import React, { useContext } from "react";
import { useSelector } from "react-redux";
import { getImgById } from "../../../../utils/utils";
import { ENUM_ELEMENT_ID } from "../../../common/enums";
import useBlockHeight from "../../../../hooks/site/useBlockHeight";
import "./zoomist-wrapper.scss";
import useStreamStatus from "../../../../hooks/site/useStreamStatus";
import { useAppSelector } from "../../../../store/index.ts";
import { CanvasContextRef, ZoomContextRef } from "../../../../pages/CurrentModel.jsx";
import LastFrame from "./video_canvas/last_frame/LastFrame.jsx";

export default function ZoomistContainer() {
  const canvasRef = useContext(CanvasContextRef);
  const divZoomRef = useContext(ZoomContextRef);
  const { isStream, status } = useStreamStatus();
  const zoomistHeight = useAppSelector((state) => state.siteInfo.blockHeight.zoomistHeight);
  const loadingBroadcaster = useAppSelector((state) => state.chat.loadingBroadcaster);

  // попробовать вынести, что бы было меньше рендеров

  const broadcasterId = useSelector((state) => state.chat.broadcaster.id);
  const { zoomContainerHeightStyle } = useBlockHeight();

  const styleContainer = {
    ...zoomContainerHeightStyle,
    height: zoomistHeight ? zoomistHeight + "px" : undefined,
    display: isStream ? undefined : "none",
  };
  const styleBgBlur = { backgroundImage: `url(${getImgById(broadcasterId)})` };

  console.log("loadingBroadcaster && isStream", loadingBroadcaster, status);

  return (
    <div
      className="zoomist-container"
      id={ENUM_ELEMENT_ID.zoomistContainer}
      ref={divZoomRef}
      style={styleContainer}
    >
      <div className="bg-blur" style={styleBgBlur} />

      <div className="zoomist-wrapper" id={ENUM_ELEMENT_ID.zoomistWrapper}>
        <LastFrame loader={loadingBroadcaster && isStream} />

        <div className="zoomist-image">
          <canvas ref={canvasRef} />
        </div>
      </div>
    </div>
  );
}
